import sw from '@uswitch/ev-utils/switch'
import loadable from '@loadable/component'

// Playbook version of PostcodeCaptureForm available from https://github.com/uswitch/recharge-eevee/tree/a0f4480b5c3af2bfbf46e735ab49fb6a493a7845/packages/ev-core/src/components/modules/lead-capture-form

const RegistrationPostcodeForm = loadable(() => import('./registration-postcode-form'))
const EmailCaptureForm = loadable(() => import('./email-capture-form'))

const LeadCaptureForm = ({ variant, ...props }) =>
  sw({
    'email-capture': () => <EmailCaptureForm variant={variant} {...props} />,
    'email-capture-no-privacy-policy': () => (
      <EmailCaptureForm variant={variant} hidePrivacy={true} {...props} />
    ),
    'car-insurance': () => <RegistrationPostcodeForm variant={variant} {...props} />,
    postcode: () => <RegistrationPostcodeForm variant={variant} {...props} />,
    'postcode-secondary': () => <RegistrationPostcodeForm variant={variant} {...props} />,
    'postcode-slimline': () => <RegistrationPostcodeForm variant={variant} {...props} />,
    'car-insurance-slimline': () => <RegistrationPostcodeForm variant={variant} {...props} />,
    'home-insurance-postcode': <RegistrationPostcodeForm variant={variant} {...props} />,
    'home-insurance-postcode-cstack': <RegistrationPostcodeForm variant={variant} {...props} />,
    'broadband-postcode-slimline': <RegistrationPostcodeForm variant={variant} {...props} />,
    default: () => <RegistrationPostcodeForm variant={variant} {...props} />,
  })(variant, { ...props, variant })

export default LeadCaptureForm
